export const ALLOWED_CRYPTOS_FOR_FUTURES = ['btc', 'eth', 'tbtc', 'teth'];
